/**
 * Loại thu 
 * dvhung2 28.02.2025
 */
export default {
    /**
     * Số tổng
     */
    TotalAmount: 1,
    /**
     * Số nộp nsnn
     */
    SubmitAmount: 2,
    
}